export function GoogleAdsIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className}
        width="62" 
        height="56" 
        viewBox="0 0 62 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M20.8574 7.05129C21.4498 5.49624 22.2643 4.06461 23.4738 2.9045C28.3118 -1.81001 36.3092 -0.62521 39.5921 5.29878C42.0604 9.79113 44.6769 14.1848 47.2193 18.6277L59.9559 40.7933C63.4857 46.9888 59.6597 54.8134 52.6496 55.8748C48.3547 56.5166 44.3313 54.5419 42.1098 50.6913L30.9035 31.2409C30.8295 31.0928 30.7308 30.9694 30.632 30.846C30.2371 30.5251 30.0643 30.0561 29.8175 29.6365L21.5732 15.3449C20.6105 13.6664 20.1662 11.8398 20.2156 9.91455C20.2897 8.92722 20.4131 7.93989 20.8574 7.05129Z" 
          fill="#3C8BD9" 
        />
        <path 
          d="M20.8569 7.05176C20.6348 7.94036 20.4373 8.82895 20.3879 9.76692C20.3139 11.8403 20.8322 13.7656 21.8689 15.5675L29.9898 29.6123C30.2366 30.0319 30.4341 30.4515 30.6809 30.8464L26.2132 38.5229L19.9683 49.2848C19.8696 49.2848 19.8449 49.2355 19.8202 49.1614C19.7955 48.964 19.8696 48.7912 19.919 48.5937C20.931 44.8912 20.0917 41.6083 17.5493 38.7944C15.9943 37.0913 14.0196 36.1287 11.7487 35.8078C8.78673 35.3882 6.17029 36.1533 3.82536 38.0046C3.40574 38.3255 3.13423 38.7944 2.64056 39.0413C2.54182 39.0413 2.49246 38.9919 2.46777 38.9179L5.9975 32.7717L20.6841 7.32327C20.7335 7.22454 20.8076 7.15049 20.8569 7.05176Z" 
          fill="#FABC04" 
        />
        <path 
          d="M2.56653 38.991L3.97349 37.7322C9.97156 32.993 18.981 36.424 20.2892 43.9277C20.6101 45.7295 20.4373 47.4574 19.8943 49.1852C19.8696 49.3333 19.8449 49.4567 19.7956 49.6048C19.5734 49.9998 19.3759 50.4194 19.1291 50.8143C16.9323 54.4427 13.6988 56.2446 9.45321 55.9731C4.59057 55.6275 0.76464 51.9744 0.0981872 47.1365C-0.222697 44.7916 0.246288 42.5948 1.45578 40.5707C1.70261 40.1264 1.99881 39.7315 2.27033 39.2872C2.39375 39.1885 2.34438 38.991 2.56653 38.991Z" 
          fill="#34A852" 
        />
        <path 
          d="M2.56637 38.9918C2.46764 39.0905 2.46764 39.2633 2.29485 39.288C2.27017 39.1152 2.3689 39.0165 2.46764 38.8931L2.56637 38.9918Z" 
          fill="#FABC04" 
        />
        <path 
          d="M19.7958 49.6052C19.697 49.4324 19.7958 49.309 19.8945 49.1855L19.9932 49.2843L19.7958 49.6052Z" 
          fill="#E1C025" 
        />
      </svg>
    )
  }